import React from "react";
import { Link } from "react-router-dom";

export default function DashbaordCourseCard({
  dataCard,
  icon,
  title,
  courseDetail,
}) {
  return (
      <div
        className="student-dashboard-course-card card-animate h-100"
        data-card={dataCard}
      >
        <Link>
          <div className="icon-circle mb-22 d-flex align-items-center justify-content-center bg-white rounded-circle">
            {icon}
          </div>
          <h5 className="fw-bold mb-14 ah-text-md">{title}</h5>
          <div className="info-box d-flex justify-content-between p-10">
            <span className="d-flex align-items-center justify-content-center">
              <span className="icon icon-book"></span> {courseDetail.watch}
            </span>
            <span className="d-flex align-items-center justify-content-center">
              <i className="icon icon-assignments"></i>{" "}
              {courseDetail.assignment}
            </span>
            <span className="d-flex align-items-center justify-content-center">
              <span className="icon icon-student-members"></span>{" "}
              {courseDetail.student}
            </span>
          </div>
        </Link>
      </div>
  );
}
